import { FolderRow } from 'ui/indexPages/folders/folderRow/FolderRow';
import { FolderClosed } from 'ui/icons';
import { SearchParamLink } from 'ui/utility/SearchParamLink/SearchParamLink';
import { ListSubfolder } from 'modules/domains/list';
import { FOLDER_ID_SEARCH_PARAM, PAGE_SEARCH_PARAM } from '../../constants';

export type Props = {
  folder: ListSubfolder;
};

export const ListFolderRow = ({ folder }: Props) => {
  const { id: folderId, name: folderName } = folder;
  return (
    <FolderRow id={folderId.toString()}>
      <div /> {/* TODO: add checkbox here */}
      <FolderClosed data-test="folder-icon" />
      <SearchParamLink
        searchParams={{
          [FOLDER_ID_SEARCH_PARAM]: folderId.toString(),
        }}
        deleteSearchParams={[PAGE_SEARCH_PARAM]}
      >
        {folderName}
      </SearchParamLink>
      {/* TODO: add overflow menu here */}
    </FolderRow>
  );
};
